import { struct } from 'io-ts/Decoder';

import { Id as UserId } from '../user/Id';

import { Id as NotificationId } from './Id';

export const ComplexId = struct({
	userId: UserId,
	notificationId: NotificationId,
});
